import List from '@eduzz/houston-ui/List';
import ModalActions from 'components/ModalActions';
import Spin from 'components/Spin';
import React from 'react';
import { toast } from 'react-toastify';

import Alpaclass from './Alpaclass/index';
import File from './File';
import Nutror from './Nutror';
import Other from './Other';

interface IProps {
  deliveries: any;
  onEditSomething: any;
  offer?: any;
}

interface IStates {
  open: boolean;
  onOk: any;
  item: any;
}

class DeliveryList extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      open: false,
      onOk: null,
      item: null,
    };
  }

  onEditDelivery = (newItem: any, oldItem: any) => {
    const { onEditSomething, deliveries } = this.props;
    let newDeliveries = [...deliveries];
    const index = newDeliveries.findIndex((item: any) => item.url === oldItem.url);
    newDeliveries[index] = newItem;
    let oldName = oldItem && oldItem.method_name ? oldItem.method_name : oldItem.nutror_name;
    let newName = newItem && newItem.method_name ? newItem.method_name : newItem.nutror_name;
    toast.success(`Item ${oldName} alterado para ${newName} com sucesso!`);
    if (onEditSomething) {
      onEditSomething(newDeliveries);
    }
  };

  onRemoveDelivery = (item: any, index: number) => {
    const onOk = () => {
      const { onEditSomething, deliveries } = this.props;
      let newDeliveries = deliveries;
      newDeliveries.splice(index, 1);
      this.setState({ open: false });
      toast.success(`Item ${item} removido com sucesso!`);
      if (onEditSomething) {
        onEditSomething(newDeliveries);
      }
    };
    this.setState({ open: true, onOk, item });
  };
  onRemoveFile = (item: any, index: number, file: number) => {
    const onOk = () => {
      const { onEditSomething, deliveries } = this.props;
      let newDeliveries = [...deliveries];
      newDeliveries[index].files.splice(file, 1);
      if (newDeliveries[index].files.length === 0) {
        delete newDeliveries[index];
      }
      this.setState({ open: false });
      toast.success(`Item ${item} removido com sucesso!`);
      if (onEditSomething) {
        onEditSomething(newDeliveries);
      }
    };
    this.setState({ open: true, onOk, item });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const { item, onOk } = this.state;
    const { deliveries } = this.props;
    return (
      <>
        <List dividers>
          {deliveries && deliveries.isFetching && <Spin />}
          {deliveries && deliveries.length > 0 ? (
            deliveries.map((item: any, index: number) => {
              switch (String(item.method_id)) {
                case '5': // Files
                  return (
                    Array.isArray(item.files) &&
                    item.files.map((d: any, fileIndex: number) => {
                      return <File file={d} onRemove={this.onRemoveFile} itemIndex={index} index={fileIndex} key={`file-${d}`} />;
                    })
                  );
                case '24': //Nutror
                  return <Nutror nutror={item} onRemove={this.onRemoveDelivery} onEdit={this.onEditDelivery} index={index} key={`nutror-${index}`} />;
                case '47':
                  return (
                    <Alpaclass
                      other={item}
                      onRemove={this.onRemoveDelivery}
                      onEdit={this.onEditDelivery}
                      index={index}
                      key={`other-${index}`}
                      offer={this.props.offer}
                    />
                  );
                default:
                  // Others
                  return (
                    <Other
                      deliveries={deliveries}
                      other={item}
                      onRemove={this.onRemoveDelivery}
                      onEdit={this.onEditDelivery}
                      index={index}
                      key={`other-${index}`}
                      offer={this.props.offer}
                    />
                  );
              }
            })
          ) : (
            <List.Item>
              <List.Text title='Nenhuma entrega cadastrada' />
            </List.Item>
          )}
        </List>
        <ModalActions title={'Atenção'} open={this.state.open} onClose={this.handleClose} onOk={onOk} buttonOk='Excluir'>
          <p>{`Você realmente deseja excluir a entrega ${item} ?`}</p>
        </ModalActions>
      </>
    );
  }
}

export default DeliveryList;
